<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="storages"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="storage"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :storage="scope.row"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'name',
        order: 'ascending',
      },
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['storage/tableConfig']));
    },
    loading() {
      return this.$store.getters['storage/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('storage/setFilterString', '');
    this.$store.commit('storage/setCurrentPage', this.currentPage);
    this.$store.commit('storage/setSorting', this.currentSort);
    await this.$store.dispatch('storage/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('storage/setCurrentPage', val);
      this.$store.dispatch('storage/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      this.$store.commit('storage/setSorting', {
        prop,
        order
      });
      this.$store.dispatch('storage/fetchAll');
    },
  },
};
</script>

